function handlePropagation(event: React.BaseSyntheticEvent) {
  event.preventDefault();
  event.stopPropagation();
}

function getIs50Chance() {
  return Math.random() < 0.5;
}

const general = {
  handlePropagation,
  getIs50Chance,
};

export default general;
